import { render } from "./add-clinic-appointment.vue?vue&type=template&id=55f7161a&scoped=true"
import script from "./add-clinic-appointment.vue?vue&type=script&lang=js"
export * from "./add-clinic-appointment.vue?vue&type=script&lang=js"

import "./add-clinic-appointment.vue?vue&type=style&index=0&id=55f7161a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f7161a"]])

export default __exports__